import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var SchoolSVG = function SchoolSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M37.506,32.429c-.026,0-.052.012-.077.012v-.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M38.506,35.429c-.026,0-.052.012-.077.012v-.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M37,39.98a1.217,1.217,0,0,1-1.214,1.214H6.643A3.638,3.638,0,0,1,3,37.551V32.694a3.638,3.638,0,0,1,3.643-3.643h9.071C13.054,26.6,11.5,21.1,11.5,19.337a5.865,5.865,0,0,1,6-6.071,5.785,5.785,0,0,1,2.5.582h2.429a5.781,5.781,0,0,1,2.5-.582,5.865,5.865,0,0,1,6,6.071c0,1.761-1.555,7.261-4.214,9.714h9.071A1.218,1.218,0,0,1,37,30.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M35.86,27.14v2.57h-27a1.285,1.285,0,1,1,0-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M35.86,32.3v2.56l-27,.01a1.285,1.285,0,1,1,0-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M30.71,14.29c0,2.35-2.72,9-4.71,9a2.973,2.973,0,0,1-1.08-.43,3.683,3.683,0,0,0-3.84,0,3.129,3.129,0,0,1-1.08.43c-1.99,0-4.71-6.65-4.71-9a3.649,3.649,0,0,1,3.78-3.86,5.866,5.866,0,0,1,2.1.73,3.658,3.658,0,0,0,1.83.46,3.532,3.532,0,0,0,1.81-.46,6.082,6.082,0,0,1,2.12-.73A3.649,3.649,0,0,1,30.71,14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M39.71,34.86H38.43V27.14h1.28a1.285,1.285,0,1,0,0-2.57H28.82c2.82-2.6,4.47-8.42,4.47-10.28a6.215,6.215,0,0,0-6.36-6.43,7.234,7.234,0,0,0-2.64.7v-.7a1.178,1.178,0,0,1,1.29-1.29A1.285,1.285,0,1,0,25.57,4a3.754,3.754,0,0,0-3.86,3.86v.7a7.234,7.234,0,0,0-2.64-.7,6.215,6.215,0,0,0-6.36,6.43c0,1.86,1.65,7.68,4.47,10.28H8.86A3.85,3.85,0,0,0,5,28.43v5.14a3.85,3.85,0,0,0,3.86,3.86H39.71a1.285,1.285,0,1,0,0-2.57ZM19.07,10.43a5.866,5.866,0,0,1,2.1.73,3.658,3.658,0,0,0,1.83.46,3.532,3.532,0,0,0,1.81-.46,6.082,6.082,0,0,1,2.12-.73,3.649,3.649,0,0,1,3.78,3.86c0,2.35-2.72,9-4.71,9a2.973,2.973,0,0,1-1.08-.43,3.683,3.683,0,0,0-3.84,0,3.129,3.129,0,0,1-1.08.43c-1.99,0-4.71-6.65-4.71-9A3.649,3.649,0,0,1,19.07,10.43ZM35.86,34.86l-27,.01a1.285,1.285,0,1,1,0-2.57h27Zm0-5.15h-27a1.285,1.285,0,1,1,0-2.57h27Z"
  }));
};
SchoolSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
SchoolSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "School")
};
export default withDetailedIcon(SchoolSVG);